import React from "react";
import TransactionPayoutList from "routes/payout/TransactionPayoutList";

const Transaction = () => {
  return (
    <div className="transaction-page-container">
      <TransactionPayoutList />
    </div>
  );
};

export default Transaction;